import { UserIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import {
  getTimeawayDecisionLabel,
  getTimeawayTypeLabel,
} from '../../../utils/timeaway';

type TimeawayTableProps = {
  myTimeaway: any[];
  onCancelRequest?: (timeawayId: string) => Promise<void> | void;
};

export function TimeawayTable({ myTimeaway, onCancelRequest }: TimeawayTableProps) {
  const [cancellingId, setCancellingId] = useState<string | null>(null);

  const canCancel = (decision?: string) =>
    decision === 'pending' || decision === 'awaiting_employee_updates';

  const handleCancel = async (timeawayId: string) => {
    if (!onCancelRequest) return;
    try {
      setCancellingId(timeawayId);
      await onCancelRequest(timeawayId);
    } finally {
      setCancellingId(null);
    }
  };

  return (
    <>
      <div className="overflow-hidden rounded-lg border px-7 py-2 shadow-sm">
        <div className=" flow-root w-full">
          <div className="overflow-x-auto">
            <div className="inline-block min-w-full align-middle">
              <table className="w-full divide-y divide-gray-300">
                <thead>
                  <th
                    scope="col"
                    className=" flex items-center gap-3 py-3.5 pl-4 text-left text-sm font-semibold text-gray-500 sm:pl-0"
                  >
                    Employee
                  </th>
                  <th
                    scope="col"
                    className="px-2 py-3.5 text-left text-sm font-semibold text-gray-500"
                  >
                    Leave type
                  </th>
                  <th
                    scope="col"
                    className="px-2 py-3.5 text-left text-sm font-semibold text-gray-500"
                  >
                    Dates Requested
                  </th>
                  <th
                    scope="col"
                    className="px-2 py-3.5 text-left text-sm font-semibold text-gray-500"
                  >
                    Duration
                  </th>
                  <th
                    scope="col"
                    className="px-2 py-3.5 text-left text-sm font-semibold text-gray-500"
                  >
                    Approval status
                  </th>
                  <th
                    scope="col"
                    className="px-2 py-3.5 text-left text-sm font-semibold text-gray-500"
                  >
                    Actions
                  </th>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {myTimeaway &&
                    myTimeaway?.map((user: any) => (
                      <tr key={user.id}>
                        <td className="whitespace-nowrap py-2 pl-4 text-sm font-medium text-gray-900 sm:pl-0">
                          <div className="flex items-center gap-2">
                            <UserIcon className="w-5" />
                            {user?.full_name}
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm ">
                          {getTimeawayTypeLabel(user?.type)}
                        </td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                          {user?.start} - {user?.end}
                        </td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                          {user?.details}
                        </td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm ">
                          {user.decision === 'pending' ? (
                            <div className="flex max-w-[90px] justify-center rounded-lg bg-[#FFEDD5] px-2 py-1 text-[#C2410C]">
                              Pending
                            </div>
                          ) : user.decision === 'approved' ? (
                            <p className="flex max-w-[90px] justify-center rounded-lg bg-[#DCFCE7] px-2 py-1 text-[#15803D]">
                              Approved
                            </p>
                          ) : user.decision === 'declined' ? (
                            <div className="flex max-w-[90px] justify-center rounded-lg bg-[#FEE2E2] px-2 py-1 text-[#DC2626]">
                              Rejected
                            </div>
                          ) : (
                            <div className="flex max-w-[200px] justify-center text-wrap rounded-lg bg-[#FEF9C3] px-2 py-1 text-[#A16207]">
                              {getTimeawayDecisionLabel(user?.decision)}
                            </div>
                          )}
                        </td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm">
                          {onCancelRequest && canCancel(user?.decision) ? (
                            <button
                              type="button"
                              onClick={() => handleCancel(user.id)}
                              className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 disabled:opacity-60"
                              disabled={cancellingId === user.id}
                            >
                              {cancellingId === user.id ? 'Cancelling...' : 'Cancel'}
                            </button>
                          ) : (
                            <span className="text-gray-400">—</span>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
